export const pattern = /^(\/$)|(\d{4}-\d{1,2}-\d{1,2})$/;

export const statuses = {
    0: 'Alle',
    1: 'Aangevraagd',
    2: 'Goedgekeurd',
    3: 'Besteld',
    4: 'Nog niet volledig geleverd',
    5: 'Gedeeltelijk geleverd',
    6: 'Volledig geleverd',
};

export const sortFieldOptions = [
    { value: 'created', label: 'Datum' },
    { value: 'profilecode', label: 'Artikel' },
    { value: 'amount', label: 'Aantal' },
    { value: 'amountordered', label: 'Te bestellen' },
    { value: 'comments', label: 'Opmerkingen' },
    { value: 'profilesupplier', label: 'Leverancier' },
    { value: 'profilesupplierprofilecode', label: 'Art Nr Lev' },
    { value: 'profilebin', label: 'BIN' },
    { value: 'profileunit', label: 'Eenheid' },
    { value: 'profilepackageperunit', label: 'Verpakking' },
    { value: 'profileminstock', label: 'Min Stock' },
    { value: 'profilemaxstock', label: 'Max Stock' },
    { value: 'profilecurrentstockcount', label: 'Huidige stock' },
    { value: 'profilesparestockcount', label: 'Reservestock' },
    { value: 'profilenetto', label: 'Prijs' },
    { value: 'employee', label: 'Werknemer' },
    { value: 'status', label: 'Status' },
    { value: 'dateordered', label: 'Datum besteld' },
    { value: 'deliverydate', label: 'Leverdatum' },
];

export const sortOrderOptions = [
    { value: 'ASC', label: 'Oplopend' },
    { value: 'DESC', label: 'Aflopend' },
];

export const clearedFilters = {
    notes: '',
    profile: '',
    bin: '',
    supplier: '',
    status: '4',
    sort: 'desc',
    order: 'created',
};
